import React, { useEffect, useState, useRef } from "react";
import "./App.css";
// import Papa from 'papaparse';
import getData from "./google-sheets";

import InfiniteLooper from "./infitiny";
import PriceTable from "./components/PriceTable";
import logo from "./assets/logo.png";
import headerBg from "./assets/header-background.png";
import moment from "moment";
import "moment-lunar";
import ImageSwiper from "./components/image-swiper";

import ZaloImage from "./assets/zalo.webp";
import BannerAsset01 from "./assets/bannerHL_0000_line.png";
import Chart from "./components/chart";
import ContactWidget from "./components/ContactWidget";
import CurrencyTable from "./components/CurrencyTable";

function App() {
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState("home");

  const addresses = [
    {
      text: "Cơ sở 1: Kiot mặt đường chợ Bo (Cổng chợ Bo)",
      zalo: "0983871117",
    },
    {
      text: "Cơ sở 2: 17a Khu Thống Nhất - thị trấn Bo (Cạnh shop Táo Đỏ - ngã 3 thị trấn Bo)",
      zalo: "0965871117",
    },
    {
      text: "Cơ sở 3: 34 Khu Thống Nhất - thị trấn Bo (Đối diện cơ sở 1 mặt đường chợ Bo)",
      zalo: "0979871117",
    },
  ];

  useEffect(() => {
    try {
      getData().then((data) => {
        setData(data);
      });
    } catch (e) {
      console.log(e);
    }
  }, []);
  return (
    <div className="App w-screen min-h-screen overflow-x-hidden">
      <header className="flex items-center justify-center px-4 header">
        <div className="w-3/12 md:w-2/12">
          <img src={logo} alt="logo" className="logo mx-auto" />
        </div>
        <div className="text-center w-6/12">
          <p className="text-yellow-400 uppercase font-serif tracking-widest text-[14px] md:text-[20px]">
            Doanh nghiệp tư nhân{" "}
          </p>
          <h1 className="text-yellow-400 font-serif font-bold uppercase text-[30px] md:text-[50px] my-1 md:my-2 leading-tight">
            VÀNG BẠC HÀ LAN
          </h1>
          <img
            src={BannerAsset01}
            alt="banner decoration"
            className="w-full max-w-xs md:max-w-full mx-auto h-auto opacity-80"
          />
        </div>
        <div className="w-3/12 md:w-2/12">
          <img src={logo} alt="logo" className="logo mx-auto" />
        </div>
      </header>

      <div>
        <ImageSwiper />
      </div>
      <div className="body-container">
        <div className="menu-container">
          <div
            className={`menu-item ${activeTab === "home" ? "active" : ""}`}
            onClick={() => setActiveTab("home")}
          >
            TRANG CHỦ
          </div>
          <div
            className={`menu-item ${activeTab === "charts" ? "active" : ""}`}
            onClick={() => setActiveTab("charts")}
          >
            BIỂU ĐỒ
          </div>
          <div
            className={`menu-item ${activeTab === "currency" ? "active" : ""}`}
            onClick={() => setActiveTab("currency")}
          >
            NGOẠI TỆ
          </div>
        </div>
        {activeTab === "home" ? (
          <>
            <div className="body info">
              <PriceTable data={data} />
            </div>
          </>
        ) : activeTab === "currency" ? (
          <div className="body info">
            <CurrencyTable />
          </div>
        ) : (
          <Chart />
        )}
      </div>
      <ContactWidget />
      <footer className="bg-red-900 text-yellow-400 w-full overflow-hidden">
        <div className="mx-auto">
          <div className="border-t-2 border-b-2 border-yellow-400 py-6 mb-6">
            <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 tracking-wide uppercase">
              DOANH NGHIỆP TƯ NHÂN VÀNG BẠC HÀ LAN
            </h1>
            <div className="space-y-2 text-[13px] md:text-sm text-white px-2">
              <p>Giấy chứng nhận ĐKDN số: 037168007877</p>
              <p>Do Sở Kế hoạch và Đầu tư Tỉnh Hòa Bình cấp: 13/10/2023</p>
              <p className="">Trụ sở kinh doanh: Kiot chợ Bo, xã Kim Bôi, tỉnh Phú Thọ</p>
              <p>Số điện thoại liên hệ: 0983871117</p>
              <p>Tên người đại diện: Phạm Thị Lan</p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-2">
            {addresses.map((item, index) => (
              <div className="text-center w-full md:w-[30%]" key={index}>
                <h3 className="text-[13px] font-bold mb-2">{item.text}</h3>

                <div className="text-sm flex items-center justify-center gap-2 text-white">
                  Số điện thoại: {item.zalo}{" "}
                  <a
                    href={`https://zalo.me/${item.zalo.replace(/\s/g, "")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[30px]"
                  >
                    <img
                      src={ZaloImage}
                      alt="Zalo"
                      className="address-icon mx-auto rounded-xl"
                    />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
